import React from "react";
import cs from "classnames";
// import { useTranslation } from "react-i18next";

import { useShopContext } from "../../../lib/context/ShopContext/ShopContext";

// import { ShopSelectOptions } from "./ShopSelect/ShopSelect";
import {
  Select as MobileSelect,
  SortSelectOption
} from "../../GeneralFilters/SortSelect/Select";

import "./ShopFilterActions.scss";

interface Props {
  className?: string;
  btnFilterClassName?: string;

  selectInitialValue?: string;
  selectHidden?: boolean;
  selectClassName?: string;
}

const sameOptions = [
  { value: "SLUG-ASC", label: "Shkronjës A" },
  { value: "SLUG-DESC", label: "Shkronjës ZH" },
  { value: "PRICE-DESC", label: "Cmimit më të lartë" },
  { value: "PRICE-ASC", label: "Cmimit më të ulët" }
];

// const desktopSelectOptions: ShopSelectOptions[] = [...sameOptions];

export const ShopFilterActions = (props: Props) => {
  // const { t } = useTranslation();
  const shopCtx = useShopContext();

  const mobileSelectOptions: SortSelectOption[] = [
    { value: "", label: "Radhit sipas", isPlaceholder: true },
    ...sameOptions
  ];

  // const initialOption = desktopSelectOptions.find(
  //   (o) => o.value === shopCtx?.data?.order
  // );
  // const selectedOptions = initialOption
  //   ? [initialOption]
  //   : ([] as ShopSelectOptions[]);

  const hanleMobileSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (shopCtx.handlers?.handleOrderChange) {
      shopCtx.handlers.handleOrderChange(e.target.value);
    }
  };

  // const handleOnSelect = (selectedOption?: ShopSelectOptions) => {
  //   const value =
  //     selectedOption && selectedOption?.value ? selectedOption.value : "";
  //
  //   if (shopCtx.handlers?.handleOrderChange) {
  //     shopCtx.handlers.handleOrderChange(value);
  //   }
  // };

  return (
    <div className={cs("ShopFilterActions", props.className)}>
      {!props.selectHidden && (
        <>
          <MobileSelect
            value={shopCtx?.data?.order || ""}
            className={cs("ShopFilterActions__btn", props.selectClassName)}
            name="products-order"
            options={mobileSelectOptions}
            onChange={hanleMobileSelectChange}
          />

          {/*<ShopSelect*/}
          {/*  closeOnSelect*/}
          {/*  disableMultiselect*/}
          {/*  showSelectedOption*/}
          {/*  relativeIcon*/}
          {/*  label={t(actions.orderBy)}*/}
          {/*  selected={selectedOptions}*/}
          {/*  options={desktopSelectOptions}*/}
          {/*  onSelect={(selectedOptions) => handleOnSelect(selectedOptions)}*/}
          {/*  className="ShopFilterActions__btn ShopFilterActions__order_desktop"*/}
          {/*/>*/}
        </>
      )}
    </div>
  );
};
